import { del } from "../../../../http";
import { SubscriptionItem } from "../../../types";

import { subscriptionsBaseApiUrl } from "../../subscriptionsBaseUrl";

export const deleteSubscription = async (item: SubscriptionItem) => {
  await del(`${subscriptionsBaseApiUrl}/SubscriptionManagement/${item.id}`);
};
